const reducer = (state = '', action) =>{
    switch(action.type){
        case "setRebateSummaryPeriod": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  